<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Seçenek</label>
            <input type="text" v-model="value.Value" placeholder="Seçenek" class="form-control"/>
        </div>
        <div class="col-12">
            <b-form-checkbox v-model="value.DescriptionRequired">Açıklama Gerekli</b-form-checkbox>
        </div>
    </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'

export default{
    components:{
        BFormCheckbox
    },
    props:{
        value:Object
    }
}
</script>